import { createEnumParam, useQueryParam, withDefault } from 'use-query-params'

const tabs = ['filters', 'record-search'] as const

type TabValues = (typeof tabs)[number]

const FilterTabParam = withDefault(createEnumParam([...tabs] as const), tabs[0])

export function useInventoryFilterTab() {
  const [filterTab, setFilterTab] = useQueryParam('filter-tab', FilterTabParam)

  return { filterTab, setFilterTab }
}

export function checkValidTab(tab: string | null): tab is TabValues {
  if (!tab) {
    return false
  }

  return (tabs as readonly string[]).includes(tab)
}
